import { _t } from "core/language";

const AiHowToCook = ({recipe, loading}: any) => {

  return (
    <div className="rounded-lg bg-[#FFFAEE] py-5 px-3.5 space-y-[24px]">
      <div className="flex flex-col">
        <div className="mb-2">
          <label className="text-dark font-medium text-[13px]">
            {_t("aiChef.recipe.description")}
          </label>
        </div>
        {loading ? (
          <div className="animate-pulse">
            <div className="space-y-3">
              <div className="grid grid-cols-3 gap-4">
                <div className="h-3 bg-gray-300 rounded col-span-3"></div>
                <div className="h-3 bg-gray-300 rounded col-span-3"></div>
                <div className="h-3 bg-gray-300 rounded col-span-2"></div>
              </div>
            </div>
          </div>
        ) : (
          <div className="ml-5 font-normal">
            <ul className="list-disc">
              <li className="text-[#333333] text-[13px]">
                {recipe.content?.description}
              </li>
            </ul>
          </div>
        )}
      </div>
      <div className="flex flex-col">
        <div className="mb-2">
          <label className="text-dark font-medium text-[13px]">
            {_t("aiChef.recipe.calories")}
          </label>
        </div>
        {loading ? (
          <div className="animate-pulse">
            <div className="space-y-3">
              <div className="grid grid-cols-3 gap-4">
                <div className="h-3 bg-gray-300 rounded col-span-3"></div>
              </div>
            </div>
          </div>
        ) : (
          <div className="ml-5 font-normal">
            <ul className="list-disc">
              <li className="text-[#333333] text-[13px]">
                {recipe.content?.calories}
              </li>
            </ul>
          </div>
        )}
      </div>
      <div className="flex flex-col">
        <div className="mb-2">
          <label className="text-dark font-medium text-[13px]">
            {_t("aiChef.recipe.time")}
          </label>
        </div>
        {loading ? (
          <div className="animate-pulse">
            <div className="space-y-3">
              <div className="grid grid-cols-3 gap-4">
                <div className="h-3 bg-gray-300 rounded col-span-3"></div>
              </div>
            </div>
          </div>
        ) : (
          <div className="ml-5 font-normal">
            <ul className="list-disc">
              <li className="text-[#333333] text-[13px]">
                {recipe.content?.cooking_duration}
              </li>
            </ul>
          </div>
        )}
      </div>
      <div className="flex flex-col">
        <div className="mb-2">
          <label className="text-dark font-medium text-[13px]">
            {_t("aiChef.recipe.ingredient")}
          </label>
        </div>
        {loading ? (
          <div className="animate-pulse">
            <div className="space-y-3">
              <div className="grid grid-cols-3 gap-4">
                <div className="h-3 bg-gray-300 rounded col-span-3"></div>
                <div className="h-3 bg-gray-300 rounded col-span-1"></div>
              </div>
            </div>
          </div>
        ) : (
          <div className="ml-5 font-normal">
            <ul className="list-disc">
              <li className="text-[#333333] text-[13px]">
                {recipe.content?.ingredient
                  ?.filter((e: any) => e.type !== 'spice')
                  ?.filter((e: any) => e.id)
                  ?.map((e: any) => e.name).join(', ')
                }
              </li>
            </ul>
          </div>
        )}
      </div>
      <div className="flex flex-col">
        <div className="mb-2">
          <label className="text-dark font-medium text-[13px]">
            {_t("aiChef.recipe.spice")}
          </label>
        </div>
        {loading ? (
          <div className="animate-pulse">
            <div className="space-y-3">
              <div className="grid grid-cols-3 gap-4">
                <div className="h-3 bg-gray-300 rounded col-span-2"></div>
              </div>
            </div>
          </div>
        ) : (
          <div className="ml-5 font-normal">
            <ul className="list-disc">
              <li className="text-[#333333] text-[13px]">
                {recipe.content?.ingredient
                  ?.filter((e: any) => e.type === 'spice')
                  ?.filter((e: any) => e.id)
                  ?.map((e: any) => e.name).join(', ')
                }
              </li>
            </ul>
          </div>
        )}
      </div>
      <div className="flex flex-col">
        <div className="mb-2">
          <label className="text-dark font-medium text-[13px]">
            {_t("aiChef.recipe.tip")}
          </label>
        </div>
        {loading ? (
          <div className="animate-pulse flex w-full">
            <div className="flex-1 space-y-6 py-1">
              <div className="space-y-3">
                <div className="grid grid-cols-3 gap-4 place-items-center">
                  <div className="h-3 w-full bg-gray-300 rounded col-span-3"></div>
                  <div className="h-3 w-full bg-gray-300 rounded col-span-2"></div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="ml-5 font-normal">
            <ul className="list-disc">
              <li className="text-[#333333] text-[13px]">
                {recipe.content?.tip}
              </li>
            </ul>
          </div>
        )}
      </div>
    </div>
  )
}

export default AiHowToCook
